export const DOWNLOAD_PROCESS_STATEMENT_RTF_SUCCESS = 'DOWNLOAD_PROCESS_STATEMENT_RTF_SUCCESS';

export const downloadProcessStatementRtfFileSuccess = processStatement => ({
    type: DOWNLOAD_PROCESS_STATEMENT_RTF_SUCCESS,
    payload: { processStatement },
});
